// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router","783": "lib-react",}[chunkId] || chunkId) + "." + {"122": "21a578a4","137": "d6d5df8b","354": "9c6094ad","535": "15d1ed47","783": "e9f74c6e","795": "b2fcce65","928": "854d7ef6",}[chunkId] + ".js"
}